import * as React from "react";
import type { SVGProps } from "react";
const SvgActiveBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path fill="#D6DBE7" d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14" />
    <path
      fill="#041E78"
      d="M11.756 6.345 8.01 10.093a1 1 0 0 1-1.414 0L4.827 8.325a.7.7 0 0 1 .99-.99L7.302 8.82l3.464-3.465a.7.7 0 0 1 .99.99"
    />
  </svg>
);
export default SvgActiveBlue;
